import { useBusiness } from './BusinessProvider';

// Every tenant query key starts with the business id, so switching business never shows cached
// data from the previous one.
export function useTenantKey() {
  const { selectedId } = useBusiness();
  return (...parts: unknown[]) => ['tenant', selectedId, ...parts] as const;
}
